import React from 'react'
import { classToFComponent, FCClassContext, Field, FieldHelp, FieldLabel } from 'src/utils/views'
import { FilterExtraCnpjScope } from '../../tcm_scopes'

import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

import { chipSx } from 'src/utils/views'

type FilterExtraCnpjViewProps = {
    className?: string
    scope: FilterExtraCnpjScope
}

class FilterExtraCnpjViewClass implements FCClassContext<FilterExtraCnpjViewProps> {
    scope!: FilterExtraCnpjScope

    onSyncState({ scope }: FilterExtraCnpjViewProps) {
        this.scope = scope
    }

    render({ className, scope }: FilterExtraCnpjViewProps): React.JSX.Element {
        return (
            <Field className={className}>
                <FieldLabel>Modo de busca</FieldLabel>
                <div>
                    <Tooltip title="Clique para alternar o modo">
                        <Chip
                            size="small"
                            clickable
                            label={scope.cloning ? 'Clonagem' : 'Normal'}
                            sx={chipSx(scope.cloning ? 'purple' : 'blue')}
                            onClick={this.emitOnModeChanged}
                        />
                    </Tooltip>
                </div>
                <FieldHelp>No modo clonagem o CNPJ informado traz também as empresas do mesmo grupo.</FieldHelp>
            </Field>
        )
    }

    emitOnModeChanged = () => {
        this.scope.onModeChange(!this.scope.cloning)
    }
}

export const FilterExtraCnpjView = classToFComponent(FilterExtraCnpjViewClass, React)
export default FilterExtraCnpjView
